import { AccessibleSVG, type AccessibleSVGProps } from '@core/svg'

/**
 *
 */
export const CloseIcon: React.FC<AccessibleSVGProps> = (props) => {
  return (
    <AccessibleSVG width="100%" height="100%" viewBox="0 0 15 15" {...props}>
      <path
        d="M14 1L1 14"
        stroke={props.stroke || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M14 14L0.999999 1"
        stroke={props.stroke || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </AccessibleSVG>
  )
}
